import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PETE_PARAMETER_LENGTH_LIMIT } from "@faire/web--source/common/consts/PETE_CONSTANTS";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { logError } from "@faire/web--source/common/logging";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { HistoryTiming } from "@faire/web--source/common/performance/HistoryTiming";
import { trackPerformanceBreakdownInUserPerceivedLoadTiming } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/integration/trackPerformanceBreakdownInUserPerceivedLoadTiming";
import { getSettingUPLTPageNameEnablePageUpdateFix } from "@faire/web--source/common/settings/getSettingUPLTPageNameEnablePageUpdateFix";
import { theFuture } from "@faire/web--source/common/theFuture";
import { trackInfraUpltTimingTracePageLoaded } from "@faire/web-api--source/events/infra/timing/uplt";
import { trackInfraUpltTimingTracePageReady } from "@faire/web-api--source/events/infra/timing/uplt";
import { trackInfraUpltTiming } from "@faire/web-api--source/events/infra/timing/uplt";
import { trackInfraUserPerceivedLoadTimingTiming, trackInfraUserPerceivedLoadTimingTimingTraceMeasurementcompleted, trackInfraUserPerceivedLoadTimingTimingTracePageready } from "@faire/web-api--source/events/infra/timing/userPerceivedLoadTiming";
import { trackInfraUalEventView } from "@faire/web-api--source/events/infra/view/ualEvent";
import { TelemetryManager } from "../../opentelemetry/TelemetryManager";
import { detectQuietMainThread } from "../detectQuietMainThread";
import { trackPageWeight } from "../trackPageWeight";
import { getGlobalPerformanceMarks } from "../TrackPerformanceBreakdown/getGlobalPerformanceMarks";
import { trackQuietMainThread } from "../trackQuietMainThread";
import { AbortNotifier } from "./AbortNotifier";
import { ActionStartTimeStore } from "./ActionStartTimeStore";
import { PageLoadTracker } from "./PageLoadTracker";
import { waitForImagesToLoad } from "./waitForImagesToLoad";
var ONE_HOUR_IN_MS = 3600000;
var DEFAULT_OPTIONS = {
  numComponents: 1,
  ignoreImages: false,
  waitForPageLoadTimeoutMs: 30000,
  waitForComponentMountTimeoutMs: 5000,
  actionStartTime: 0,
  enableDebugLogging: false,
  enableTrackPerformanceBreakdown: false,
  enablePageUpdateFix: false,
  trackResultCallback: function trackResultCallback() {},
  mainThreadMaxWaitTimeMs: 500,
  mainThreadFrameLatencyThresholdMs: 50,
  mainThreadFrameLatencyThresholdMsV1_1: 250,
  errors: []
};
export var UserPerceivedLoadTiming = /*#__PURE__*/function () {
  function UserPerceivedLoadTiming(options, timings) {
    var _this = this;
    _classCallCheck(this, UserPerceivedLoadTiming);
    this.targetElements = [];
    this.isActionReady = false;
    this.hasMountTimerExpired = false;
    this.notifier = new AbortNotifier();
    this.actionStartTime = 0;
    this.actionReadyTime = 0;
    this.pageMountTime = undefined;
    this.readyToFetchDataTime = undefined;
    this.dataFetchedTime = undefined;
    this.renderedWithDataTime = undefined;
    this.pageJsExecutedTime = undefined;
    this.globalPerformanceMarks = undefined;
    this.debugInstanceId = Math.round(Math.random() * 1000);
    this.hasCompleted = false;
    this.start = function (optionsOverride) {
      if (_this.isActionReady) {
        return;
      }
      _this.debugLog("started");
      if (optionsOverride) {
        _this._options = _objectSpread(_objectSpread({}, _this._options), optionsOverride);
      }
      var _getWindowOrThrow = getWindowOrThrow(),
        document = _getWindowOrThrow.document,
        performance = _getWindowOrThrow.performance;
      _this.isActionReady = true;
      _this.actionReadyTime = performance.now();
      _this.initialPath = getCurrentPath().toString();
      if (_this.loadType === undefined && _this.options.actionStartTime) {
        _this.loadType = "ACTION";
        _this.actionStartTime = _this.options.actionStartTime;
        _this.clearActionStartTime();
      } else if (_this.loadType === undefined) {
        var _HistoryTiming$get = HistoryTiming.get(),
          timeOfLastRouteChange = _HistoryTiming$get.timeOfLastRouteChange;
        _this.actionStartTime = timeOfLastRouteChange;
        _this.loadType = getPageLoadType(timeOfLastRouteChange, _this.pageMountTime, PageLoadTracker.get().wasPageLoaded(_this.options.name));
      }
      if (_this.loadType !== "ACTION") {
        PageLoadTracker.get().setPageLoaded(_this.options.name);
        _this.globalPerformanceMarks = getGlobalPerformanceMarks();
        trackPageWeight(_this.initialPath, _this.options.name, _this.loadType, _this.actionStartTime);
        if (document.visibilityState === "hidden") {
          _this.trackResult({
            status: "PAGE_STARTED_HIDDEN"
          });
          _this.sendResultPromise = Promise.resolve();
          return;
        }
      }
      var timeoutId = setTimeout(function () {
        _this.hasMountTimerExpired = true;
        _this.startMeasurementIfReady();
      }, _this.options.waitForComponentMountTimeoutMs);
      _this.notifier.addAbortListener(function () {
        clearTimeout(timeoutId);
      });
      _this.startMeasurementIfReady();
    };
    this.cancel = function () {
      if (!_this.isActionReady) {
        return;
      }
      _this.targetElements = [];
      _this.clearActionStartTime();
      _this.notifier.abort("CANCELLED");
      _this.debugLog("cancelled");
    };
    this.debugLog = function () {
      if (_this.options.enableDebugLogging) {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        // eslint-disable-next-line no-console
        (_console = console).log.apply(_console, ["UPLT", _this.debugInstanceId].concat(args));
      }
    };
    this.clearActionStartTime = function () {
      ActionStartTimeStore.get().cleanActionStartTime(_this.options.name);
    };
    this.notifyPageMount = function () {
      _this.pageMountTime = getWindowOrThrow().performance.now();
    };
    this.notifyPageUnmount = function () {
      _this.notifier.abort("PARENT_COMPONENT_UNMOUNTED");
    };
    this.notifyReadyToFetchData = function () {
      _this.readyToFetchDataTime = getWindowOrThrow().performance.now();
    };
    this.notifyRenderedWithData = function () {
      _this.renderedWithDataTime = getWindowOrThrow().performance.now();
    };
    this.setDataUpdatedAt = function (dataUpdatedAt) {
      // `dataUpdatedAt` comes from Date.now() via useQuery(). It relative to the UNIX epoch.
      // UPLT uses timestamps returned by performance.now(). They are relative to `timeOrigin`.
      _this.dataFetchedTime = timeRelativeToTimeOrigin(dataUpdatedAt);
    };
    this.setPageJsExecutedMark = function (mark) {
      _this.pageJsExecutedTime = mark === null || mark === void 0 ? void 0 : mark.startTime;
    };
    this.setIgnoreImages = function (ignoreImages) {
      _this._options = _objectSpread(_objectSpread({}, _this._options), {}, {
        ignoreImages: ignoreImages
      });
    };
    this.setNumComponents = function () {
      var numComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_OPTIONS.numComponents;
      _this._options = _objectSpread(_objectSpread({}, _this._options), {}, {
        numComponents: numComponents
      });
      _this.startMeasurementIfReady();
    };
    this.refCallback = function (element) {
      if (element) {
        _this.targetElements.push(element);
        _this.startMeasurementIfReady();
      } else {
        _this.targetElements = [];
        _this.notifier.abort("TARGET_COMPONENT_UNMOUNTED");
      }
      _this.debugLog("refCallback called", element);
    };
    this.startMeasurementIfReady = function () {
      if (_this.sendResultPromise) {
        return;
      }
      var componentsMissing = _this.targetElements.length < _this.options.numComponents;
      var waitingForComponents = !_this.hasMountTimerExpired && componentsMissing;
      if (waitingForComponents || !_this.isActionReady) {
        return;
      }
      if (_this.notifier.aborted) {
        _this.trackResult({
          status: _this.notifier.reason || "UNKNOWN_ERROR"
        });
        _this.sendResultPromise = Promise.resolve();
      } else if (componentsMissing) {
        _this.trackResult({
          status: "TARGET_COMPONENT_MISSING"
        });
        _this.sendResultPromise = Promise.resolve();
      } else {
        theFuture(_this.options.waitForPageLoadTimeoutMs).then(function () {
          _this.notifier.abort("TIMEOUT");
        });
        trackQuietMainThread(_this.options.name, _this.loadType, _this.notifier);
        var measurementV1_1 = startMeasurement(_this.targetElements, _this.notifier, _this.options.ignoreImages, _this.options.mainThreadMaxWaitTimeMs, _this.options.mainThreadFrameLatencyThresholdMsV1_1, _this.options.errors).catch(function () {
          return {
            status: _this.notifier.reason || "UNKNOWN_ERROR"
          };
        }).then(_this.trackResultV1_1);
        var measurementV1 = startMeasurement(_this.targetElements, _this.notifier, _this.options.ignoreImages, _this.options.mainThreadMaxWaitTimeMs, _this.options.mainThreadFrameLatencyThresholdMs).catch(function () {
          return {
            status: _this.notifier.reason || "UNKNOWN_ERROR"
          };
        }).then(_this.trackResult);
        _this.sendResultPromise = Promise.all([measurementV1_1, measurementV1]).then(function () {
          // Trigger all abort listeners, to clean up any remaining listeners.
          _this.notifier.abort("CLEAN_UP");
          _this.hasCompleted = true;
        });
      }
    };
    this.trackResultV1_1 = function (result) {
      var _this$pageMountTime, _result$mainThreadQui, _result$lastImageLoad2, _metaInfoPayLoad$load, _this$loadType, _TelemetryManager$get, _this$loadType2, _TelemetryManager$get2;
      var _getWindowOrThrow2 = getWindowOrThrow(),
        performance = _getWindowOrThrow2.performance;
      var _HistoryTiming$get2 = HistoryTiming.get(),
        timeOfLastRouteChange = _HistoryTiming$get2.timeOfLastRouteChange;
      var hasPageChanged = _this.actionStartTime < timeOfLastRouteChange && (
      /* The last route change might have changed part of the URL,
       * but stayed on the same page (eg. opening a modal).
       * Let's only consider it a navigation, if the page component
       * or some of the content components unmount.
       */
      _this.notifier.reason === "PARENT_COMPONENT_UNMOUNTED" || _this.notifier.reason === "TARGET_COMPONENT_UNMOUNTED");
      var endTime;
      if (hasPageChanged) {
        endTime = timeOfLastRouteChange;
      } else if (result.mainThreadQuietTime) {
        var _result$lastImageLoad;
        endTime = Math.max(result.mainThreadQuietTime, (_result$lastImageLoad = result.lastImageLoadTime) !== null && _result$lastImageLoad !== void 0 ? _result$lastImageLoad : 0);
      } else {
        endTime = performance.now();
      }
      var metaInfoPayLoad = {
        name: _this.options.name,
        variant: _this.options.variant,
        isInitialLoad: _this.actionStartTime === 0,
        loadType: _this.loadType,
        isSSR: getGlobalProperty("needsHydration", false)
      };
      var relativeEndTime = _this.getTimeDeltaWithClampMax(endTime);
      var status = result.status;
      if (status === "FAILURE") {
        // If the status is already a failure, we don't want to change the status
      } else if (hasPageChanged) {
        status = "PAGE_NAVIGATED";
      } else if (relativeEndTime < 0) {
        status = "NEGATIVE_END_TIME";
      }
      var resultPayload = {
        status: status,
        pageMountTime: _this.getTimeDeltaWithClampMax((_this$pageMountTime = _this.pageMountTime) !== null && _this$pageMountTime !== void 0 ? _this$pageMountTime : null),
        pageReadyTime: _this.getTimeDeltaWithClampMax(_this.actionReadyTime),
        mainThreadQuietTime: _this.getTimeDeltaWithClampMax((_result$mainThreadQui = result.mainThreadQuietTime) !== null && _result$mainThreadQui !== void 0 ? _result$mainThreadQui : null),
        lastImageLoadTime: _this.getTimeDeltaWithClampMax((_result$lastImageLoad2 = result.lastImageLoadTime) !== null && _result$lastImageLoad2 !== void 0 ? _result$lastImageLoad2 : null),
        endTime: relativeEndTime
      };
      var marker = trackInfraUpltTiming(_this.options.name, (_metaInfoPayLoad$load = metaInfoPayLoad.loadType) !== null && _metaInfoPayLoad$load !== void 0 ? _metaInfoPayLoad$load : "", resultPayload.status, {
        timestampOverride: _this.actionStartTime
      });
      trackInfraUpltTimingTracePageReady(_this.options.name, (_this$loadType = _this.loadType) !== null && _this$loadType !== void 0 ? _this$loadType : "", status, (_TelemetryManager$get = TelemetryManager.get().getActiveTraceId()) !== null && _TelemetryManager$get !== void 0 ? _TelemetryManager$get : "", marker, {
        timestampOverride: _this.actionReadyTime
      });
      trackInfraUpltTimingTracePageLoaded(_this.options.name, (_this$loadType2 = _this.loadType) !== null && _this$loadType2 !== void 0 ? _this$loadType2 : "", status, (_TelemetryManager$get2 = TelemetryManager.get().getActiveTraceId()) !== null && _TelemetryManager$get2 !== void 0 ? _TelemetryManager$get2 : "", result.errors ? result.errors.join(",") : "", marker, {
        timestampOverride: endTime
      });
    };
    this.trackResult = function (result) {
      var _this$pageMountTime2, _result$mainThreadQui2, _result$lastImageLoad4, _result$numOfImages, _metaInfoPayLoad$load2, _this$options$trackRe, _this$options;
      var _getWindowOrThrow3 = getWindowOrThrow(),
        performance = _getWindowOrThrow3.performance;
      var _HistoryTiming$get3 = HistoryTiming.get(),
        timeOfLastRouteChange = _HistoryTiming$get3.timeOfLastRouteChange;
      var hasPageChanged = _this.actionStartTime < timeOfLastRouteChange && (
      /* The last route change might have changed part of the URL,
       * but stayed on the same page (eg. opening a modal).
       * Let's only consider it a navigation, if the page component
       * or some of the content components unmount.
       */
      _this.notifier.reason === "PARENT_COMPONENT_UNMOUNTED" || _this.notifier.reason === "TARGET_COMPONENT_UNMOUNTED");
      var endTime;
      if (hasPageChanged) {
        endTime = timeOfLastRouteChange;
      } else if (result.mainThreadQuietTime) {
        var _result$lastImageLoad3;
        endTime = Math.max(result.mainThreadQuietTime, (_result$lastImageLoad3 = result.lastImageLoadTime) !== null && _result$lastImageLoad3 !== void 0 ? _result$lastImageLoad3 : 0);
      } else {
        endTime = performance.now();
      }
      var isNextJS = getGlobalProperty("isNextJS", false);
      var metaInfoPayLoad = {
        name: _this.options.name,
        variant: _this.options.variant,
        isInitialLoad: _this.actionStartTime === 0,
        loadType: _this.loadType,
        isSSR: getGlobalProperty("needsHydration", false),
        isNextJS: isNextJS
      };
      var relativeEndTime = _this.getTimeDeltaWithClampMax(endTime);
      var status = result.status;
      if (hasPageChanged) {
        status = "PAGE_NAVIGATED";
      } else if (relativeEndTime < 0) {
        status = "NEGATIVE_END_TIME";
      }
      var resultPayload = {
        status: status,
        pageMountTime: _this.getTimeDeltaWithClampMax((_this$pageMountTime2 = _this.pageMountTime) !== null && _this$pageMountTime2 !== void 0 ? _this$pageMountTime2 : null),
        pageReadyTime: _this.getTimeDeltaWithClampMax(_this.actionReadyTime),
        mainThreadQuietTime: _this.getTimeDeltaWithClampMax((_result$mainThreadQui2 = result.mainThreadQuietTime) !== null && _result$mainThreadQui2 !== void 0 ? _result$mainThreadQui2 : null),
        lastImageLoadTime: _this.getTimeDeltaWithClampMax((_result$lastImageLoad4 = result.lastImageLoadTime) !== null && _result$lastImageLoad4 !== void 0 ? _result$lastImageLoad4 : null),
        endTime: relativeEndTime
      };
      var debugPayload = {
        numOfElements: _this.targetElements.length,
        numOfImages: (_result$numOfImages = result.numOfImages) !== null && _result$numOfImages !== void 0 ? _result$numOfImages : 0,
        path: undefined,
        templatedPath: getGlobalProperty("templatedPath")
      };
      var marker = trackInfraUserPerceivedLoadTimingTiming(_this.options.name, (_metaInfoPayLoad$load2 = metaInfoPayLoad.loadType) !== null && _metaInfoPayLoad$load2 !== void 0 ? _metaInfoPayLoad$load2 : "", resultPayload.status, {
        timestampOverride: _this.actionStartTime
      });
      _this.trackTrace(status, marker, isNextJS, trackInfraUserPerceivedLoadTimingTimingTracePageready, _this.actionReadyTime);
      _this.trackTrace(status, marker, isNextJS, trackInfraUserPerceivedLoadTimingTimingTraceMeasurementcompleted, endTime);
      var metaInfoPayLoadString = JSON.stringify(metaInfoPayLoad);
      var resultPayloadString = JSON.stringify(resultPayload);
      var debugPayLoadString = JSON.stringify(debugPayload);
      if (metaInfoPayLoadString.length > PETE_PARAMETER_LENGTH_LIMIT || resultPayloadString.length > PETE_PARAMETER_LENGTH_LIMIT || debugPayLoadString.length > PETE_PARAMETER_LENGTH_LIMIT) {
        logError(new Error("UPLT result payloads exceeded the ".concat(PETE_PARAMETER_LENGTH_LIMIT, " length limit.\n          ").concat(metaInfoPayLoadString, ",\n          ").concat(resultPayloadString, ",\n          ").concat(debugPayLoadString)));
      }
      trackInfraUalEventView(JSON.stringify(metaInfoPayLoad), JSON.stringify(resultPayload), JSON.stringify(debugPayload));
      _this.debugLog("finished", metaInfoPayLoad, resultPayload, debugPayload);
      _this.trackPerformanceBreakdown(status, result, endTime);
      (_this$options$trackRe = (_this$options = _this.options).trackResultCallback) === null || _this$options$trackRe === void 0 ? void 0 : _this$options$trackRe.call(_this$options, _this.options.name, status, _this.loadType, resultPayload);
    };
    this.trackPerformanceBreakdown = function (status, result, endTime) {
      if (_this.options.enableTrackPerformanceBreakdown === "internal-tracking" && _this.globalPerformanceMarks) {
        var _this$dataFetchedTime, _this$pageMountTime3, _this$readyToFetchDat, _this$globalPerforman, _this$globalPerforman2, _this$pageJsExecutedT;
        /**
         * In case of a useQuery cache hit or prefetch, `dataFetchedTime`
         * may be before `actionStartTime` or `pageMountTime`.
         * In the case that the page does not have a data fetch
         * (ie. logged-out home), `dataFetchedTime` may be `undefined`.
         *
         * To avoid a negative segment duration, the value should not be less
         * than the end time of the previous segment.
         */
        var dataFetched = Math.max((_this$dataFetchedTime = _this.dataFetchedTime) !== null && _this$dataFetchedTime !== void 0 ? _this$dataFetchedTime : 0, _this.actionStartTime, (_this$pageMountTime3 = _this.pageMountTime) !== null && _this$pageMountTime3 !== void 0 ? _this$pageMountTime3 : 0);
        // In case of a useQuery cache hit or prefetch, `readyToFetchDataTime`
        // is not relevant (because there is no fetch about to begin).
        // The DATA segment duration should be zero if the `dataFetchedTime`
        // already happened before the component was ready.
        var readyToFetchData = Math.min(dataFetched, (_this$readyToFetchDat = _this.readyToFetchDataTime) !== null && _this$readyToFetchDat !== void 0 ? _this$readyToFetchDat : 0);
        var breakdown = {
          htmlStarted: (_this$globalPerforman = _this.globalPerformanceMarks) === null || _this$globalPerforman === void 0 ? void 0 : _this$globalPerforman.htmlStarted,
          mainJsExecuted: (_this$globalPerforman2 = _this.globalPerformanceMarks) === null || _this$globalPerforman2 === void 0 ? void 0 : _this$globalPerforman2.mainJsExecuted,
          pageComponentMounted: _this.pageMountTime,
          readyToFetchData: readyToFetchData,
          dataFetched: dataFetched,
          pageComponentRenderedWithData: _this.renderedWithDataTime,
          // readyToFetchPageJs is deprecated and not used
          readyToFetchPageJs: undefined,
          pageJsExecuted: Math.max(_this.actionStartTime, (_this$pageJsExecutedT = _this.pageJsExecutedTime) !== null && _this$pageJsExecutedT !== void 0 ? _this$pageJsExecutedT : 0)
        };
        trackPerformanceBreakdownInUserPerceivedLoadTiming({
          name: _this.options.name,
          loadType: _this.loadType,
          status: status,
          timeOfLastRouteChange: _this.actionStartTime,
          breakdown: breakdown,
          lastImageLoadTime: result.lastImageLoadTime,
          mainThreadQuietTime: result.mainThreadQuietTime,
          upltEndTime: endTime
        });
      }
    };
    this.trackTrace = function (status, marker, isNextJS, traceFunction, time) {
      var _this$loadType3, _TelemetryManager$get3;
      traceFunction(_this.options.name, (_this$loadType3 = _this.loadType) !== null && _this$loadType3 !== void 0 ? _this$loadType3 : "", status, "".concat(isNextJS), (_TelemetryManager$get3 = TelemetryManager.get().getActiveTraceId()) !== null && _TelemetryManager$get3 !== void 0 ? _TelemetryManager$get3 : "", marker, {
        timestampOverride: time
      });
    };
    this._options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
    this.pageMountTime = timings === null || timings === void 0 ? void 0 : timings.pageMountTime;
    this.setDataUpdatedAt(timings === null || timings === void 0 ? void 0 : timings.dataUpdatedAt);
    this.setPageJsExecutedMark(timings === null || timings === void 0 ? void 0 : timings.pageJsExecutedMark);
    if (isPageUpdateFixEnabled(this.options)) {
      if (options.actionStartTime) {
        this.loadType = "ACTION";
        this.actionStartTime = options.actionStartTime;
        this.clearActionStartTime();
      } else {
        var _HistoryTiming$get4 = HistoryTiming.get(),
          timeOfLastRouteChange = _HistoryTiming$get4.timeOfLastRouteChange;
        this.actionStartTime = timeOfLastRouteChange;
        this.loadType = getPageLoadTypeUsingPageJsTime(timeOfLastRouteChange, this.pageMountTime, this.pageJsExecutedTime);
      }
    }
    var startLoadTimeInteractionTracking = getGlobalProperty("startLoadTimeInteractionTracking");
    if (startLoadTimeInteractionTracking) {
      startLoadTimeInteractionTracking();
    }
  }
  return _createClass(UserPerceivedLoadTiming, [{
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "hasStarted",
    get: function get() {
      return this.isActionReady;
    }
    // eslint-disable-next-line @faire/prefer-arrow-methods
  }, {
    key: "getTimeDeltaWithClampMax",
    value: function getTimeDeltaWithClampMax(time) {
      if (time == null || time === 0) {
        return time;
      } else {
        // Cap the time to 1 hour
        return Math.min(Math.round(time - this.actionStartTime), ONE_HOUR_IN_MS);
      }
    }
  }]);
}();
var startMeasurement = function startMeasurement(targetElements, notifier, ignoreImages, maxQuietWindowWaitTimeMs, frameLatencyThresholdMs, errors) {
  var _errors$length;
  return Promise.all([detectQuietMainThread(maxQuietWindowWaitTimeMs, frameLatencyThresholdMs, notifier), ignoreImages || ((_errors$length = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _errors$length !== void 0 ? _errors$length : 0) > 0 ? Promise.resolve(null) : waitForImagesToLoad(targetElements, notifier)]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      quietMainThreadResult = _ref2[0],
      imageLoadResult = _ref2[1];
    var status;
    if (notifier.aborted) {
      status = notifier.reason || "UNKNOWN_ERROR";
    } else if (quietMainThreadResult.status === "page-hidden") {
      status = "PAGE_TRANSITIONED_TO_HIDDEN";
    } else {
      var zeroImages = imageLoadResult == null || imageLoadResult.numImages === 0;
      if (errors && errors.length > 0) {
        status = "FAILURE";
      } else if (zeroImages && !ignoreImages) {
        status = "IMAGES_MISSING";
      } else {
        status = "SUCCESS";
      }
    }
    return {
      status: status,
      mainThreadQuietTime: quietMainThreadResult === null || quietMainThreadResult === void 0 ? void 0 : quietMainThreadResult.startOfQuietWindow,
      lastImageLoadTime: imageLoadResult === null || imageLoadResult === void 0 ? void 0 : imageLoadResult.lastImageLoadTime,
      numOfImages: (imageLoadResult === null || imageLoadResult === void 0 ? void 0 : imageLoadResult.numImages) || 0,
      errors: errors
    };
  });
};
var getPageLoadType = function getPageLoadType(timeOfLastRouteChange, pageMountTime, wasPageLoaded) {
  if (pageMountTime !== undefined && pageMountTime < timeOfLastRouteChange) {
    return "PAGE_UPDATE";
  } else if (timeOfLastRouteChange > 0) {
    return wasPageLoaded ? "ROUTE_CHANGE_SUBSEQUENT" : "ROUTE_CHANGE_FIRST";
  } else {
    return "DIRECT_LOAD";
  }
};
var getPageLoadTypeUsingPageJsTime = function getPageLoadTypeUsingPageJsTime(timeOfLastRouteChange, pageMountTime, pageJsExecutedTime) {
  if (timeOfLastRouteChange > 0) {
    if (pageMountTime !== undefined && pageMountTime < timeOfLastRouteChange) {
      return "PAGE_UPDATE";
    } else if (pageJsExecutedTime !== undefined && pageJsExecutedTime < timeOfLastRouteChange) {
      return "ROUTE_CHANGE_SUBSEQUENT";
    } else {
      return "ROUTE_CHANGE_FIRST";
    }
  } else {
    return "DIRECT_LOAD";
  }
};
function timeRelativeToTimeOrigin(epochTimestamp) {
  var _getWindow, _getWindow$performanc;
  var timeOrigin = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow$performanc = _getWindow.performance) === null || _getWindow$performanc === void 0 ? void 0 : _getWindow$performanc.timeOrigin;
  if (epochTimestamp && timeOrigin) {
    return epochTimestamp - timeOrigin;
  } else {
    return undefined;
  }
}
function isPageUpdateFixEnabled(options) {
  if (options.enablePageUpdateFix) {
    return true;
  }
  var value = getSettingUPLTPageNameEnablePageUpdateFix();
  if (value === "all") {
    return true;
  } else if (typeof value === "string") {
    var pageNames = value.split(",");
    return pageNames.indexOf(options.name) >= 0;
  } else {
    return false;
  }
}